import propertiesReducer from './properties.slice';

export * from './properties.slice';
export * from './properties.thunk';

export default propertiesReducer;
